import { useQuery } from '@tanstack/react-query';
import { IriisService, iriisKeys } from '@client/services/iriisService';

/**
 * Hook to fetch IRIIS external links for a list of enemy IDs.
 * Returns a map of { enemyId: { url, title, dossier_type } }.
 *
 * @param {string[]} enemyIds - Array of enemy UUIDs
 * @returns {{ data: Object|undefined, isLoading: boolean }}
 */
export const useIriisLinks = (enemyIds) => {
  return useQuery({
    queryKey: iriisKeys.enemyLinks(enemyIds),
    queryFn: () => IriisService.getEnemyLinks(enemyIds),
    enabled: enemyIds?.length > 0,
    staleTime: 10 * 60 * 1000, // 10 minutes
  });
};

export default useIriisLinks;
